var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"modals"},[_c('Spinner',{staticClass:"spinner",attrs:{"message":_vm.loadingMsg,"textFgColor":"#ffffff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }